import { create } from 'zustand';

export const useStore = create(set => ({
  isLoggedIn: null,
  set: newData => set(state => ({ isLoggedIn: newData })),
}));
